export default function MySQL_SIN() {
  return (
    <div>
      <h2>MySQL_SIN</h2>    </div>
  );
}